export default {
    updateOpportunity(id, data) {
        return ApiClient.put(`/opportunities/${id}`, {}, data);
    },
    async getMetadata() {
        const { data } = await ApiClient.get(`/opportunities/metadata`);
        return data;
    },
};
